<div class="row m-0">
    <div class="col-lg-12 col-md-12 col-12 p-0">
        <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
            <form [formGroup]="formGroup">
                <kendo-grid [kendoGridBinding]="actionKendoList" [reorderable]="true" [sortable]="true" [resizable]="true" (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)" [filterable]="enableFilter" [pageSize]="15" [pageable]="true">
                    <ng-template kendoPagerTemplate>
                        <div class="k-pager-left">
                            <kendo-pager-info></kendo-pager-info>
                        </div>
                        <div class="k-pager-right">
                            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                            <kendo-pager-input></kendo-pager-input>
                            <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                    </ng-template>
                    <ng-template kendoGridToolbarTemplate>
                        <div class="k-grid-toolbar-content d-flex">
                            <div class="flex-grow-1 title-container">
                                <p class="title">Workflow Actions</p>
                            </div>
                            <div class="pagination-container">
                                <p id="lblShowDetails">Show</p>
                                <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                </kendo-pager-page-sizes>
                                <span>Items</span>
                            </div>
                            <div class="divider-container d-none d-md-block" id="imgDivider">
                                <span></span>
                            </div>
                            <div class="icons-container">
                                <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                                <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                    <div class="icon-wrap" (click)="toggleFilter()">
                                        <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                                        <span class="list-icon-name">Filter</span>
                                    </div>
                                    <div class="divider-container"><span></span></div>
                                    <i class="fa fa-plus-circle" (click)="openActionDialog()" *ngIf="!workflowTemplateService.isViewMode" matTooltip="Add workflow action" aria-hidden="true">
                                    </i>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <kendo-grid-column title="Possible Action" field="action_Description">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            {{dataItem.action_Description}}
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                            {{dataItem.action_Description}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Next step id" field=next_Step_Id>
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            {{dataItem.next_Step_Id}}
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            <mat-form-field>
                                <mat-label>Next Step ID</mat-label>
                                <input matInput type="number" formControlName="next_Step_Id">
                            </mat-form-field>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Capture Date for" field="statusDescription">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            {{dataItem.statusDescription}}
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            <EIPAutoComplete ShowTextValueField='N' setId="eipDD5wfStatusList" WaterMarkText="Capture Date for" [defaultValue]="dataItem.status_Id" ValueField="dedId" TextField="dedDescription" [dataSource]='actionStatusList' (valueChange)='changeWorkflowStatus($event)' [IsCascading]='true'>
                            </EIPAutoComplete>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column *ngIf='isShow' title="Approval Status">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            <span>{{dataItem.Document_CategoryList}}</span>
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            <EIPMultiSelectAutoComplete [dataSource]="documentCategoryList" required setId="typeDist" TextField="dedDescription" ValueField="dedId" isEmitOnSelect="Y" WaterMarkText="Type *" ShowTextValueField='N' [IsCascading]='true' [defaultSelectedValues]="selected_TypeCategory" (valueChange)='onTypeChange($event,dataItem)'>
                            </EIPMultiSelectAutoComplete>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Is Active" field="is_Active">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            <mat-slide-toggle [checked]="dataItem.is_Active" color="primary" disabled>
                            </mat-slide-toggle>
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            <mat-slide-toggle [checked]="dataItem.is_Active" color="primary" (change)="changeActiveStatus($event)">
                            </mat-slide-toggle>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Is Supersede" field="enable_Tag">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            <mat-slide-toggle [checked]="dataItem.enable_Tag == 1 ? true:false" color="primary" disabled>
                            </mat-slide-toggle>
                        </ng-template>
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            <mat-slide-toggle [checked]="dataItem.enable_Tag == 1 ? true:false" color="primary" (change)="changeSupersedeStatus($event)">
                            </mat-slide-toggle>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Actions">
                        <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex" *ngIf="!workflowTemplateService.isViewMode" let-dataItem="dataItem">
                            <div>
                                <button kendoGridEditCommand class="k-grid-add-command">
                                    <i class="fa fa-pencil icon-size mr-2" matTooltip="Edit" style="font-size: 20px;" id="" aria-hidden="true"></i>
                                </button>
                                <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                                    <i class="fa fa-save icon-size mr-2" matTooltip="Save" style="font-size: 20px;" id="" aria-hidden="true"></i>
                                </button>
                                <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                                    <i class="fa fa-times-circle icon-size mr-2" matTooltip="Cancel" style="font-size: 20px;" id="" aria-hidden="true"></i>
                                </button>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </form>
        </div>
    </div>
</div>